// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".searchCard[data-v-585b980a]{border:1px solid #003a63}.styleLabel[data-v-585b980a]{color:#fff;padding:5px;font-weight:700}", ""]);
// Exports
module.exports = exports;
